import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApplepodcastsComponent } from './simple-icons-applepodcasts.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApplepodcastsComponent ],
    exports:      [ SimpleIconsApplepodcastsComponent ],
    bootstrap:    []
})
export class SimpleIconsApplepodcastsModule {}
